import React from 'react'
import "../../styles/s_machine.css"
import Prodcard1 from '../../components/prodcards/Prodcard'
import img25 from '../../img/ppm/25.png'
import img26 from '../../img/ppm/26.png'

export const PpM = () => {
    const des = {
        img25: ['VOLTAGE - 220V/50Hz','POWER - 50W','MATERIAL - Stainless Steel','PACKAGING RANGE- 10-200g','DIMENSION - 500*370*810mm','PACKAGING SPEED- 5-12 Bags/Min',
            ],
            img26:['VOLTAGE - 220V/50Hz','PACKAGING RANGE- 10-999g','PACKAGING SPEED- 5-12 Bags/Min','DIMENSION - 300*500*1250mm','MATERIAL - Stainless Steel','POWER - 50W',]

    }
    return (
        <div className='prdmain'>
            <div className='head2'>
                <h1>Pouch Packing Machine</h1>
            </div>
            <div className='items1'>
                <Prodcard1
                    imageSrc={img25}
                    model={"VP PGF200"}
                    title="Powder and granule filler"
                    altText="img of websit"
                    description={des.img25}
                />
                <Prodcard1
                    imageSrc={img26}
                    model={"VP PGF999"}
                    title="Powder and granule filler"
                    altText="img of websit"
                    description={des.img26}
                />

            </div>


        </div>
    )
}
